const popups = []
const oldOpen = window.open

window.open = function () {
    const w = oldOpen.apply(this,arguments)
    popups.push(w);
    return w
}

const oldGetElementById = document.getElementById

document.getElementById = function (id){
    for (var i = 0; i< popups.length; i++){
        var w = popups[i]
        var el = w.document.getElementById(id)
        if (el) return el;
    }
    return oldGetElementById.call(document, id)
}


// WEBPACK FOOTER //
// ./src/utils/rewriteGetElements.js